module.exports = {
    advancedSearchResult: {
        en: "Advanced search result",
        fi: "Edistyneen haun tulokset"
    },
    noPostFound: {
        en: "No post found",
        fi: "Ei ilmoituksia"
    }
};